/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  getDeliveries(campaignId, params = {}) {
    return axios.get(`${this.url}/${campaignId}/deliveries`, { params });
  }

  deleteDelivery(campaignId, deliveryId) {
    return axios.delete(`${this.url}/${campaignId}/deliveries/${deliveryId}`);
  }

  clearDeliveriesForDate(campaignId, date) {
    return axios.delete(`${this.url}/${campaignId}/deliveries/clear_date`, {
      params: { date },
    });
  }

  exportDeliveries(campaignId, date) {
    return axios.get(`${this.url}/${campaignId}/deliveries/export`, {
      params: { date },
      responseType: 'blob',
    });
  }
}

export default new CampaignsAPI();
